import { Button, ButtonProps } from "antd";
import styles from "./LinkButton.module.css";

export const LinkButton: React.FC<ButtonProps & React.RefAttributes<HTMLButtonElement | HTMLAnchorElement>> = (
  props
) => (
  <Button type="link" size="middle" className={styles.button} {...props}>
    {props.children}
  </Button>
);
